import { Button, Checkbox, Form, Input, Select } from 'antd';
import { CustomDatePicker, CustomInput } from 'components/custom';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  AddressesChoice,
  GET,
  StepForm,
  contractEndReasonOptions,
  contract_start_reason,
  employment_contract,
  language,
  marriedStatus,
  mrs,
  phonesChoice,
  professional_status,
  user_profile,
  working_time_unit,
} from 'utils';
import {
  getCities,
  getCountries,
  getNationality,
} from 'utils/common_function/get_country_and_cities';
import { timeZone } from 'utils/timeZone';
import Options from './Options';
import SubmitButton from './SubmitButton';

import { DatePicker } from 'antd/lib';
import { CloseIcon, EditIcon, PLusIcon } from 'components/Icons';
import dayjs from 'dayjs';
import { api } from 'utils/apiRoutes';
import { calculateAge } from 'utils/common_function';
import {
  lengthRegex,
  lowercaseRegex,
  numberRegex,
  uppercaseRegex,
} from 'utils/regex/regexPassword';
import { checkBoxOption } from './One';

const { Item, List } = Form;

const Four: React.FC<StepForm> = ({
  form_data,
  onSubmit,
  onBack,
  fieldError,
}) => {
  const [state, setState] = useState<any>({
    countries: [],
    nationality: [],
    cities: [],
    workshift: {
      workshift_policy_id: form_data['workshifts'][0]
        ? form_data['workshifts'][0]
        : null,
      start_date: form_data['contract_start_date']
        ? dayjs(form_data['contract_start_date'])
        : '',
      end_date: '',
      cyclic_start_date: '',
    },
    editWorkshift: false,
  });
  const { countries, nationality, cities, workshift, editWorkshift } = state;
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);

  const allowedChars = /^[a-zA-Z0-9@_.]+$/;

  const holidayData = useQuery('get-holiday', () => {
    let result = null;
    try {
      result = GET('/api/public_holiday_calendar/option/');
    } catch (error) {
      console.log('error', error);
    }
    return result;
  });

  const workshiftList = useQuery(api.workShiftList, async () => {
    let result = null;
    try {
      const res = await GET(api.workShiftList + '/option/');
      result = res.data;
    } catch (error) {
      console.log('error', error);
    }
    return result;
  });

  const staffLeaveData = useQuery('get-staffleave', async () => {
    try {
      return await GET('/api/absence-policy/option/');
    } catch (error) {
      console.log('error', error);
    }
  });

  const staffLeaveList =
    staffLeaveData?.data?.data?.length > 0 &&
    staffLeaveData?.data?.data.map((item: object) => {
      return {
        label: item['name'],
        value: item['id'],
      };
    });
  const holidayList = holidayData?.data?.data.map((item: object) => ({
    label: item['name'],
    value: item['id'],
  }));

  const workShiftDetail = workshift?.workshift_policy_id
    ? workshiftList.data?.find(
      (item) => +item?.id === workshift?.workshift_policy_id,
    )
    : workshiftList.data?.find(
      (item) => +item?.id === form_data['workshifts'][0],
    );

  const addressRequired = [
    'type',
    'street_number',
    'street_name',
    'address_1',
    'postal_code',
    'country',
    'city',
  ];

  const onGetCities = (v: string) => {
    getCities(v).then((res) => {
      setState((p) => ({
        ...p,
        cities: res.data.data.map((i) => ({
          label: i,
          value: i,
        })),
      }));
    });
  };

  const disabledDateStart = (current) => {
    return dayjs() < current;
  };

  const password = values?.password || '';

  const hasLength = lengthRegex.test(password);
  const hasLowercase = lowercaseRegex.test(password);
  const hasUppercase = uppercaseRegex.test(password);
  const hasNumber = numberRegex.test(password);

  const validatePassword = (rule, value, callback) => {
    if (value?.length === 0 || !value) {
      callback('Password is required');
    }

    const hasLength = lengthRegex.test(value);
    const hasLowercase = lowercaseRegex.test(value);
    const hasUppercase = uppercaseRegex.test(value);
    const hasNumber = numberRegex.test(value);

    // Add your password validation logic here
    if (hasLength && hasLowercase && hasUppercase && hasNumber) {
      callback(); // Validation passed
    } else {
      callback('Password is invalid'); // Validation failed
    }
  };

  const passwordSuccess =
    hasLength && hasLowercase && hasUppercase && hasNumber;

  const validateEmail = (rule, value, callback) => {
    if (value?.length === 0 || !value) {
      callback('Email is required');
    }

    const hasAccents = /[áéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙâêîôÂÊÎÔãõÃÕ]/.test(
      value,
    );

    // Email validation regex
    const isValidEmail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value,
      );
    if (value && (hasAccents || !isValidEmail)) {
      callback('Invalid email address');
    } else {
      callback(); // Pass validation
    }
  };

  const handleChangeWorkShift = () => {
    setState((prev) => {
      if (!prev.editWorkshift) {
        return { ...prev, editWorkshift: true };
      }

      const dataChange = form.getFieldValue('workshift') ?? {};
      const { workshift_policy_id, start_date, end_date, cyclic_start_date } =
        dataChange;

      const formattedData = {
        workshift_policy_id,
        start_date: start_date ? dayjs(start_date) : start_date,
        end_date: end_date ? dayjs(end_date) : end_date,
        cyclic_start_date: cyclic_start_date
          ? dayjs(cyclic_start_date)
          : cyclic_start_date,
      };

      return { ...prev, workshift: formattedData, editWorkshift: false };
    });
  };

  useEffect(() => {
    getCountries().then((res) => {
      setState((pre) => ({
        ...pre,
        nationality: getNationality(),
        countries: res?.data?.data?.map((item: { country: string }) => {
          return {
            label: item?.country,
            value: item?.country,
          };
        }),
      }));
    });
  }, []);

  function removeEmptyString(obj: any) {
    const newObj = {};
    Object.keys(obj).forEach(function (key) {
      if (obj[key] !== '' && obj[key]) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }

  return (
    <div className="mt-4">
      <h1
        style={{
          fontWeight: 600,
          fontSize: 24,
          color: '#000',
          paddingBottom: 30,
        }}
        className="mb-3"
      >
        Generalities
      </h1>
      <Form
        initialValues={{
          ...form_data,
          contract_start_date:
            dayjs(form_data['contract_start_date']) || dayjs(),
          workshift: workshift,
          language: 'en',
        }}
        onFinish={(v) => {
          if (v['children_dependents']?.length > 0)
            v['children_dependents'] = v['children_dependents'].map((item) => {
              if (item?.date_of_birth)
                item.date_of_birth = dayjs(item.date_of_birth).format(
                  'YYYY-MM-DD',
                );
              return item;
            });

          onSubmit({
            ...v,
            company_start_date: v['contract_start_date'].format('YYYY-MM-DD'),
            contract_start_date: v['contract_start_date'].format('YYYY-MM-DD'),
            seniority_date: v['contract_start_date'].format('YYYY-MM-DD'),
            date_of_birth: v['date_of_birth'].format('YYYY-MM-DD'),
            contract_end_date:
              v['contract_end_date'] &&
              v['contract_end_date'].format('YYYY-MM-DD'),
            expired_date:
              v['expired_date'] && v['expired_date'].format('YYYY-MM-DD'),
            workshifts: [
              removeEmptyString({
                workshift_policy_id: workshift?.workshift_policy_id,
                start_date: workshift?.start_date
                  ? dayjs(workshift?.start_date).format('YYYY-MM-DD')
                  : '',
                end_date: workshift?.end_date
                  ? dayjs(workshift?.end_date).format('YYYY-MM-DD')
                  : '',
                cyclic_start_date: workshift?.cyclic_start_date
                  ? dayjs(workshift?.cyclic_start_date).format('YYYY-MM-DD')
                  : '',
              }),
            ],
            job_number: Math.floor(Math.random() * 100000) + 2,
            confirm_password: undefined,
          });
        }}
        form={form}
      >
        {/* General */}

        <div className="form-wrapper">
          <h1
            className="form-wrapper_title mb-3"
            style={{ fontWeight: 500, paddingBottom: 20 }}
          >
            General
          </h1>
          <div
            className="is-flex"
            style={{
              gap: 32,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
            }}
          >
            <Options
              name="title"
              options={mrs}
              required
              height="50px"
              title={'Gender'}
              width={'100%'}
              rule={[{ required: true }]}
            />
            <Item
              name={'last_name'}
              rules={[{ required: true, message: 'Last Name is required' }]}
              style={{ width: '100%' }}
            >
              <CustomInput
                maxLength={50}
                title={'Last Name'}
                height="50px"
                fontSize={12}
                required
                width={'100%'}
              />
            </Item>
            <Item
              name={'first_name'}
              rules={[{ required: true, message: 'First Name is required' }]}
              style={{ width: '100%' }}
            >
              <CustomInput
                maxLength={50}
                title={'First Name'}
                height="50px"
                fontSize={12}
                required
                width={'100%'}
              />
            </Item>
          </div>
          <div
            className="is-flex"
            style={{
              gap: 32,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
            }}
          >
            <div style={{ width: '100%' }}>
              <Item
                name={'email'}
                rules={[
                  {
                    validator: validateEmail,
                  },
                ]}
                validateStatus="error"
                help={fieldError?.email && fieldError?.email[0]}
              >
                <CustomInput
                  title={'Email Address'}
                  height="50px"
                  fontSize={12}
                  error={!!fieldError?.email}
                  onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  // onPaste={(e) => e.preventDefault()}
                  required
                  width={'100%'}
                />
              </Item>
            </div>

            <div style={{ width: '100%' }}>
              <Item
                name={'social_security_number'}
                rules={[
                  {
                    required: true,
                    message: 'Social Security Number is required',
                  },
                ]}
              >
                <CustomInput
                  title={'Social Security Number'}
                  required
                  height="50px"
                  fontSize={12}
                  width={'100%'}
                />
              </Item>
            </div>
          </div>
          <div
            style={{
              gap: 32,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
            }}
            className="is-flex mb-5"
          >
            <div style={{ width: '100%' }}>
              <Options
                name="timezone"
                title="TimeZone"
                height="50px"
                options={timeZone}
              />
            </div>
            <div style={{ width: '100%' }}>
              <Options
                name="language"
                options={language}
                height="50px"
                title="Languages"
                disabled
              />
            </div>
          </div>{' '}
          <Options
            required
            options={holidayList}
            name="public_holiday_calendar_id"
            title="Calendar ( public holidays )"
            height="50px"
            rule={[
              {
                required: true,
                message: 'Calendar ( public holidays ) is required',
              },
            ]}
          />
          <div className="my-5">
            <Item name={'comment'}>
              <CustomInput
                maxLength={50}
                title="Comments"
                height="50px"
                fontSize={12}
                width="100%"
              />
            </Item>
          </div>
        </div>
        {/* ---- */}

        {/* Contact*/}
        <div
          className="form-wrapper my-5"
          style={{
            paddingBottom: 40,
          }}
        >
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Contact Details
          </h1>
          <section className={'mt-4'}>
            <Item
              name={'personal_email'}
              rules={[
                {
                  validator:
                    form.getFieldValue('personal_email')?.length > 0 &&
                    validateEmail,
                },
              ]}
            >
              <CustomInput
                title={'Personal Email'}
                height="50px"
                onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => e.preventDefault()}
                fontSize={12}
                width={'100%'}
              />
            </Item>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
                gap: 32,
                alignItems: 'center',
                marginBottom: 24,
              }}
            >
              <div className={'is-flex'} style={{ gap: 10, width: '100%' }}>
                <Item
                  name={'linkedin'}
                  style={{
                    width: '100%',
                    marginBottom: 0,
                  }}
                >
                  <CustomInput
                    maxLength={100}
                    title={'LinkedIn'}
                    height="50px"
                    fontSize={12}
                    placeholder={'linkedin.com/in/user'}
                    width={'100%'}
                  />
                </Item>{' '}
                <img
                  src="/icons/linkedin.svg"
                  alt="linkedin"
                  height={35}
                  width={35}
                />
              </div>
              <div className={'is-flex'} style={{ gap: 10, width: '100%' }}>
                <Item
                  name={'viadeo'}
                  style={{
                    width: '100%',
                    marginBottom: 0,
                  }}
                >
                  <CustomInput
                    maxLength={100}
                    title={'Viadeo'}
                    height="50px"
                    fontSize={12}
                    placeholder={'viadeo.com/en/profile/user'}
                    width={'100%'}
                  />
                </Item>{' '}
                <img
                  src="/icons/vladeo.svg"
                  alt="vladeo"
                  height={35}
                  width={35}
                />
              </div>
              <div className={'is-flex'} style={{ gap: 10, width: '100%' }}>
                <Item
                  name={'twitter'}
                  style={{
                    width: '100%',
                    marginBottom: 0,
                  }}
                >
                  <CustomInput
                    title={'Twitter'}
                    height="50px"
                    fontSize={12}
                    placeholder={'twitter.com/user'}
                    width={'100%'}
                  />
                </Item>
                <img
                  src="/icons/twitter.svg"
                  alt="linkedin"
                  height={35}
                  width={35}
                />
              </div>
              <div className={'is-flex'} style={{ gap: 10, width: '100%' }}>
                <Item
                  name={'facebook'}
                  style={{
                    width: '100%',
                    marginBottom: 0,
                  }}
                >
                  <CustomInput
                    title={'Facebook'}
                    height="50px"
                    fontSize={12}
                    placeholder={'facebook.com/user'}
                    width={'100%'}
                  />
                </Item>{' '}
                <img
                  src="/icons/facebook.svg"
                  alt="linkedin"
                  height={35}
                  width={35}
                />
              </div>
            </div>
            <div className="mt-3">
              <h2 style={{ fontWeight: 400, fontSize: 16, color: '#000' }}>
                Addresses
              </h2>
              <List name="addresses">
                {(fields, { add, remove }) => (
                  <>
                    <Item>
                      <Button
                        onClick={() => add()}
                        type="text"
                        icon={<PLusIcon />}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        disabled={form
                          .getFieldValue('addresses')
                          ?.some((field) => !field)}
                      >
                        <span
                          style={{
                            color: '#407FDD',
                          }}
                        >
                          Add item
                        </span>
                      </Button>
                    </Item>

                    <div
                      className="is-flex is-justify-content-space-between py-2 px-4"
                      style={{
                        background: '#EAF6FF',
                        borderTopLeftRadius: '0.625rem',
                        borderTopRightRadius: '0.625rem',
                        color: '#000',
                        textAlign: 'center',
                        boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                      }}
                    >
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Type
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Street Number
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Additional Number Information
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Street Name
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Address 1
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Address 2
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Postal Code
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        City
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      >
                        Country
                      </span>
                      <span
                        style={{
                          width: '10rem',
                          color: '#000',
                          fontWeight: 500,
                        }}
                      />
                    </div>
                    <div
                      className="py-2 px-4"
                      style={{
                        background: '#FFF',
                        borderBottomLeftRadius: '0.625rem',
                        borderBottomRightRadius: '0.625rem',
                        color: fields.length === 0 ? '#E4E4E4' : '#000',
                        textAlign: 'center',
                        boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                      }}
                    >
                      {fields.length === 0 ? (
                        'No item'
                      ) : (
                        <>
                          {fields.map(({ key, name, ...rest }) => (
                            <div
                              key={key}
                              style={{
                                gap: 10,
                                display: 'grid',
                                gridTemplateColumns:
                                  'repeat(10, minmax(0, 1fr))',
                              }}
                              className="form-list"
                            >
                              <span className="select_type">
                                <Item name={[name, 'type']}>
                                  <Select
                                    options={AddressesChoice}
                                    suffixIcon={
                                      <img
                                        src="/icons/arrow_select.svg"
                                        alt="arrow"
                                        className="mb-1 mr-1"
                                        style={{ marginTop: 6 }}
                                      />
                                    }
                                  // style={{ width: '7rem' }}
                                  />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item name={[name, 'street_number']} {...rest}>
                                  <Input />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item
                                  name={[name, 'additional_number_info']}
                                  {...rest}
                                >
                                  <Input />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item name={[name, 'street_name']} {...rest}>
                                  <Input />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item name={[name, 'address_1']} {...rest}>
                                  <Input />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item name={[name, 'address_2']} {...rest}>
                                  <Input />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item name={[name, 'postal_code']} {...rest}>
                                  <Input />
                                </Item>
                              </span>
                              <span className="add_item_input">
                                <Item name={[name, 'city']} {...rest}>
                                  <Input />
                                </Item>
                              </span>
                              <span className="select_type">
                                <Item name={[name, 'country']}>
                                  <Select
                                    options={countries}
                                    suffixIcon={
                                      <img
                                        src="/icons/arrow_select.svg"
                                        alt="arrow"
                                        className="mb-1 mr-1"
                                        style={{ marginTop: 6 }}
                                      />
                                    }
                                  // style={{ width: '7rem' }}
                                  />
                                </Item>
                              </span>
                              <span>
                                <Button
                                  onClick={() => remove(name)}
                                  type="text"
                                  icon={
                                    <img src="/icons/decline.svg" alt="icon" />
                                  }
                                />
                              </span>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </>
                )}
              </List>
            </div>
            <div className="mt-3">
              <h2 style={{ fontWeight: 400, fontSize: 16, color: '#000' }}>
                Phones
              </h2>
              <div style={{ width: '50%' }}>
                <List name={'phones'}>
                  {(fields, { add, remove }) => (
                    <>
                      <Item>
                        <Button
                          onClick={() => add()}
                          type="text"
                          icon={<PLusIcon />}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          disabled={form
                            .getFieldValue('phones')
                            ?.some((field) => !field)}
                        >
                          <span
                            style={{
                              color: '#407FDD',
                            }}
                          >
                            Add item
                          </span>
                        </Button>
                      </Item>

                      <div
                        className="is-flex is-justify-content-space-between py-2 px-4"
                        style={{
                          background: '#EAF6FF',
                          borderTopLeftRadius: '0.625rem',
                          borderTopRightRadius: '0.625rem',
                          color: '#000',
                          textAlign: 'center',
                          boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                        }}
                      >
                        <span style={{ width: '28%' }}>Type</span>
                        <span style={{ width: '35%' }}>
                          Additional Information
                        </span>
                        <span style={{ width: '28%' }}>Number</span>
                        <span style={{ width: '9%' }} />
                      </div>
                      <div
                        className="py-2 px-4"
                        style={{
                          background: '#FFF',
                          borderBottomLeftRadius: '0.625rem',
                          borderBottomRightRadius: '0.625rem',
                          color: fields.length === 0 ? '#E4E4E4' : '#000',
                          textAlign: 'center',
                          boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                        }}
                      >
                        {fields.length === 0 ? (
                          'No item'
                        ) : (
                          <>
                            {fields.map(({ key, name, ...rest }) => (
                              <div
                                key={key}
                                style={{
                                  gap: 10,
                                  display: 'grid',
                                  gridTemplateColumns:
                                    'repeat(10, minmax(0, 1fr))',
                                }}
                                className=" form-list"
                              >
                                <Item
                                  name={[name, 'type']}
                                  className="select_type"
                                  style={{
                                    gridColumn: 'span 3 / span 3',
                                  }}
                                >
                                  <Select
                                    options={phonesChoice}
                                    suffixIcon={
                                      <img
                                        src="/icons/arrow_select.svg"
                                        alt="arrow"
                                        className="mb-1 mr-1"
                                        style={{ marginTop: 6 }}
                                      />
                                    }
                                    style={{ width: '100%' }}
                                  />
                                </Item>

                                <Item
                                  name={[name, 'additional_info']}
                                  {...rest}
                                  className="add_item_input"
                                  style={{
                                    gridColumn: 'span 3 / span 3',
                                  }}
                                >
                                  <Input style={{ width: '100%' }} />
                                </Item>

                                <Item
                                  name={[name, 'number']}
                                  {...rest}
                                  className="add_item_input"
                                  style={{
                                    gridColumn: 'span 3 / span 3',
                                  }}
                                >
                                  <Input
                                    style={{ width: '100%' }}
                                    type="number"
                                    onKeyPress={(e) => {
                                      // Check if the pressed key is not a digit or whitespace
                                      if (
                                        !/\d/.test(e.key) ||
                                        /\s/.test(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="disable-arrow"
                                  />
                                </Item>

                                <Button
                                  onClick={() => remove(name)}
                                  type="text"
                                  style={{
                                    margin: 'auto',
                                    marginBottom: '10px',
                                  }}
                                  icon={
                                    <img src="/icons/decline.svg" alt="icon" />
                                  }
                                />
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </>
                  )}
                </List>
              </div>
            </div>
          </section>
        </div>
        {/*--------*/}
        {/*DOB*/}
        <div className="form-wrapper">
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Date of Birth
          </h1>
          <section className={'my-5'}>
            <div
              className="is-flex is-justify-content-space-between"
              style={{
                display: 'grid',
                gap: 32,
                gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
              }}
            >
              <Item
                name={'date_of_birth'}
                style={{
                  width: '100%',
                }}
                rules={[
                  { required: true, message: 'Date of birth is required' },
                ]}
              >
                <CustomDatePicker
                  disabledDate={disabledDateStart}
                  title={'Date of Birth'}
                  required
                  height={'50px'}
                  fontSize={14}
                  borderRadius={6}
                />
              </Item>
              <Options
                name={'birth_country'}
                required
                width="100%"
                height="50px"
                title={'Country of Birth'}
                rule={[
                  { required: true, message: 'Country of Birth is required' },
                ]}
                options={countries}
                onChange={onGetCities}
              />
              <Options
                name={'birth_city'}
                required
                height="50px"
                width="100%"
                title={'City of Birth'}
                options={cities}
                rule={[
                  { required: true, message: 'City of Birth is required' },
                ]}
              />
              <Item
                name={'birth_department'}
                style={{
                  width: '100%',
                }}
              >
                <CustomInput
                  title={'Birth Department Number'}
                  height="50px"
                  width="100%"
                  fontSize={14}
                />
              </Item>
            </div>
          </section>
          <div className={'is-flex'} style={{ gap: 32 }}>
            <div style={{ width: '50%' }}>
              <Item
                name={'birth_name'}
                rules={[{ required: true, message: 'Birth name is required' }]}
              >
                <CustomInput
                  title={'Birth Name'}
                  height="50px"
                  fontSize={12}
                  required
                  width={'100%'}
                />
              </Item>
            </div>
            <div style={{ width: '50%' }}>
              <Options
                name={'nationality'}
                required
                height="50px"
                title={'Nationality'}
                rule={[{ required: true, message: 'Nationality is required' }]}
                options={nationality}
              />
            </div>
          </div>
        </div>
        {/*---*/}
        {/*Status*/}
        <div
          className="form-wrapper mt-5"
          style={{
            paddingBottom: 30,
          }}
        >
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Status
          </h1>
          <Options
            name={'marital_status'}
            width={'50%'}
            height="50px"
            title={'Maritial Status'}
            options={marriedStatus}
          />
          <h1
            style={{
              fontWeight: 400,
              fontSize: 16,
              color: '#000',
              margin: '32px 0px 8px 0px',
            }}
          >
            Children and Dependents
          </h1>
          <List name="children_dependents">
            {(fields, { add, remove }) => (
              <>
                <Item>
                  <Button
                    onClick={() => add()}
                    type="text"
                    icon={<PLusIcon />}
                    disabled={form
                      .getFieldValue('children_dependents')
                      ?.some((field) => !field)}
                  >
                    <span
                      style={{
                        color: '#407FDD',
                      }}
                    >
                      Add item
                    </span>
                  </Button>
                </Item>

                <div
                  className=" py-2 px-4"
                  style={{
                    background: '#EAF6FF',
                    borderTopLeftRadius: '0.625rem',
                    borderTopRightRadius: '0.625rem',
                    color: '#000',
                    textAlign: 'center',
                    boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(15, minmax(0, 1fr))',
                    gap: 10,
                  }}
                >
                  <span style={{ color: '#000', fontWeight: 500 }}>Number</span>
                  <span
                    style={{
                      gridColumn: 'span 2 / span 2',
                      color: '#000',
                      fontWeight: 500,
                    }}
                  >
                    Link
                  </span>
                  <span
                    style={{
                      gridColumn: 'span 3 / span 3',
                      color: '#000',
                      fontWeight: 500,
                    }}
                  >
                    Last Name
                  </span>
                  <span
                    style={{
                      gridColumn: 'span 3 / span 3',
                      color: '#000',
                      fontWeight: 500,
                    }}
                  >
                    First Name
                  </span>
                  <span
                    style={{
                      gridColumn: 'span 3 / span 3',
                      color: '#000',
                      fontWeight: 500,
                    }}
                  >
                    Date of Birth
                  </span>
                  <span
                    style={{
                      color: '#000',
                      fontWeight: 500,
                    }}
                  >
                    Age
                  </span>
                  <span style={{ color: '#000', fontWeight: 500 }}>
                    Dependent
                  </span>
                  <span style={{ color: '#000', fontWeight: 500 }} />
                </div>
                <div
                  className="py-2 px-4"
                  style={{
                    background: '#FFF',
                    borderBottomLeftRadius: '0.625rem',
                    borderBottomRightRadius: '0.625rem',
                    color: fields.length === 0 ? '#E4E4E4' : '#000',
                    textAlign: 'center',
                    boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                  }}
                >
                  {fields.length === 0 ? (
                    'No item'
                  ) : (
                    <>
                      {fields.map(({ key, name, ...rest }, index) => (
                        <div
                          key={key}
                          style={{
                            gap: 10,
                            gridTemplateColumns: 'repeat(15, minmax(0, 1fr))',
                            display: 'grid',
                          }}
                          className=" form-list"
                        >
                          <span>{index + 1}</span>
                          <span
                            style={{
                              gridColumn: 'span 2 / span 2',
                            }}
                          >
                            <Item
                              name={[name, 'link']}
                              {...rest}
                              className="select_type"
                            >
                              <Select
                                options={[
                                  { value: 'child', label: 'Child' },
                                  { value: 'other', label: 'Other' },
                                ]}
                                suffixIcon={
                                  <img
                                    src="/icons/arrow_select.svg"
                                    alt="arrow"
                                    className="mb-1 mr-1"
                                    style={{ marginTop: 5 }}
                                  />
                                }
                              />
                            </Item>
                          </span>
                          <span
                            style={{
                              gridColumn: 'span 3 / span 3',
                            }}
                          >
                            <Item
                              name={[name, 'last_name']}
                              {...rest}
                              className="add_item_input"
                            >
                              <Input maxLength={100} />
                            </Item>
                          </span>
                          <span
                            style={{
                              gridColumn: 'span 3 / span 3',
                            }}
                          >
                            <Item
                              name={[name, 'first_name']}
                              {...rest}
                              className="add_item_input"
                            >
                              <Input maxLength={100} />
                            </Item>
                          </span>
                          <span
                            style={{
                              gridColumn: 'span 3 / span 3',
                            }}
                          >
                            <Item
                              name={[name, 'date_of_birth']}
                              {...rest}
                              className="edit_item_date custom-suffix"
                            >
                              <DatePicker
                                inputReadOnly
                                style={{
                                  width: '100%',
                                }}
                                disabledDate={disabledDateStart}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    [name, 'age'],
                                    value !== null
                                      ? +calculateAge(value)
                                      : null,
                                  );
                                }}
                                suffixIcon={
                                  <img
                                    src="/icons/calendar.svg"
                                    alt="icon"
                                    width={20}
                                  />
                                }
                              />
                            </Item>
                          </span>
                          <span className="add_item_input">
                            <Input
                              type="number"
                              maxLength={3}
                              value={form.getFieldValue([name, 'age'])}
                              readOnly
                            />
                          </span>
                          <span
                            className="add_item_checkbox"
                            style={{
                              marginBottom: 10,
                            }}
                          >
                            {/* <Item name={[name, 'dependent']} {...rest}> */}
                            <Checkbox
                              style={{
                                height: '100%',
                              }}
                            />
                            {/* </Item> */}
                          </span>

                          <span>
                            <Button
                              onClick={() => remove(name)}
                              type="text"
                              icon={<img src="/icons/decline.svg" alt="icon" />}
                            />
                          </span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </>
            )}
          </List>
        </div>
        {/*------*/}
        {/*Contract*/}
        <div className="form-wrapper mt-5">
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Contract
          </h1>
          <div className="is-flex my-4" style={{ gap: 32 }}>
            <div style={{ width: '50%' }}>
              <Item
                name={'contract_start_date'}
                rules={[
                  {
                    required: true,
                    message: 'Contract Start Date is required',
                  },
                ]}
              >
                <CustomDatePicker
                  height={'50px'}
                  fontSize={12}
                  borderRadius={6}
                  title={'Contract Start Date'}
                  required
                  disabledDate={(current) => {
                    const endDate = dayjs(
                      form.getFieldValue('contract_end_date'),
                    );
                    if (form.getFieldValue('contract_end_date'))
                      return current > endDate;
                  }}
                />
              </Item>
              <Checkbox checked className={'mt-2'}>
                Date of arrival at company and seniority date identical to
                contract start date
              </Checkbox>
            </div>
            <div style={{ width: '50%' }}>
              <Options
                name={'contract_start_reason'}
                title={'Contract Start Reason'}
                height="50px"
                options={contract_start_reason}
                required
                rule={[
                  {
                    required: true,
                    message: 'Contract Start Date is required',
                  },
                ]}
              />
            </div>
          </div>
          <div className="mt5">
            <h1
              style={{
                fontWeight: 500,
                fontSize: 16,
                color: '#000',
                marginTop: 32,
              }}
            >
              Work Shift Calendars
            </h1>
            <div
              style={{
                marginTop: 16,
                gap: 8,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <img src="/icons/attention.svg" alt="arrow" />
              <span style={{ color: '#E02C2C', fontSize: 14, fontWeight: 400 }}>
                If there is no date defined in the table below, the company’s
                default work shift calendar is applied.
              </span>
            </div>
            <div className="my-4">
              <div
                className="  py-2 px-4"
                style={{
                  background: '#EAF6FF',
                  borderTopLeftRadius: '0.625rem',
                  borderTopRightRadius: '0.625rem',
                  color: '#000',
                  textAlign: 'center',
                  boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                  display: 'grid',
                  gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
                  gap: 10,
                }}
              >
                <span
                  style={{
                    color: '#000',
                    fontWeight: 500,
                    gridColumn: 'span 3/ span 3',
                    textAlign: 'center',
                  }}
                >
                  Work Shift Calendars
                </span>
                <span
                  style={{
                    color: '#000',
                    fontWeight: 500,
                    gridColumn: 'span 2 / span 2',
                  }}
                >
                  Start Date
                </span>
                <span
                  style={{
                    color: '#000',
                    fontWeight: 500,
                    gridColumn: 'span 2 / span 2',
                  }}
                >
                  End Date
                </span>
                <span
                  style={{
                    gridColumn: 'span 4 / span 4',
                    color: '#000',
                    fontWeight: 500,
                  }}
                >
                  Start Date of Clylic Work Shift Calendar
                </span>
                <span />
              </div>
              <div
                className="py-2 px-4"
                style={{
                  background: '#FFF',
                  borderBottomLeftRadius: '0.625rem',
                  borderBottomRightRadius: '0.625rem',
                  color: '#000',
                  textAlign: 'center',
                  boxShadow: '0px 2px 8px 0px rgba(14, 48, 99, 0.25)',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
                    gap: 10,
                  }}
                >
                  <span
                    style={{
                      gridColumn: 'span 3 / span 3',
                    }}
                  >
                    {editWorkshift ? (
                      <Item
                        name={['workshift', 'workshift_policy_id']}
                        className="select_type"
                      >
                        <Select
                          style={{ textAlign: 'left' }}
                          options={
                            Array.isArray(workshiftList?.data) &&
                            workshiftList?.data.map((item) => ({
                              label: item['name'],
                              value: item['id'],
                            }))
                          }
                          suffixIcon={
                            <img
                              src="/icons/arrow_select.svg"
                              alt="arrow"
                              className="mb-1 mr-1"
                              style={{ marginTop: '5px' }}
                            />
                          }
                        />
                      </Item>
                    ) : (
                      <span style={{ color: '#E02C2C' }}>
                        {workShiftDetail?.name}
                      </span>
                    )}
                  </span>
                  <span
                    style={{
                      gridColumn: 'span 2 / span 2',
                    }}
                  >
                    {editWorkshift ? (
                      <Item
                        name={['workshift', 'start_date']}
                        className="add_item_date_new"
                      >
                        <DatePicker
                          suffixIcon={
                            <img
                              src="/icons/calendar.svg"
                              alt="icon"
                              className={'mr-3'}
                              width={18}
                            />
                          }
                          allowClear={false}
                          disabledDate={(curr) => {
                            if (form.getFieldValue('workshift')?.end_date)
                              return (
                                curr >
                                dayjs(
                                  form.getFieldValue('workshift')?.end_date,
                                ) ||
                                curr < dayjs(form_data['contract_start_date'])
                              );
                          }}
                          style={{
                            width: '100%',
                          }}
                        />
                      </Item>
                    ) : (
                      <>
                        {workshift?.start_date
                          ? dayjs(workshift?.start_date).format('YYYY-MM-DD')
                          : ''}
                      </>
                    )}
                  </span>
                  <span
                    style={{
                      gridColumn: 'span 2 / span 2',
                    }}
                  >
                    {editWorkshift ? (
                      <Item
                        name={['workshift', 'end_date']}
                        className="add_item_date_new"
                      >
                        <DatePicker
                          suffixIcon={
                            <img
                              src="/icons/calendar.svg"
                              alt="icon"
                              className={'mr-3'}
                              width={18}
                            />
                          }
                          disabledDate={(curr) => {
                            if (form.getFieldValue('workshift')?.start_date)
                              return (
                                curr <
                                dayjs(
                                  form.getFieldValue('workshift')?.start_date,
                                )
                              );
                            if (workshift.start_date)
                              return curr < dayjs(workshift.start_date);
                          }}
                          style={{
                            width: '100%',
                          }}
                        />
                      </Item>
                    ) : workshift?.end_date ? (
                      dayjs(workshift?.end_date).format('YYYY-MM-DD')
                    ) : null}
                  </span>
                  <span style={{ gridColumn: 'span 4 / span 4' }}>
                    {editWorkshift ? (
                      <Item
                        name={['workshift', 'cyclic_start_date']}
                        className="add_item_date_new"
                      >
                        <DatePicker
                          suffixIcon={
                            <img
                              src="/icons/calendar.svg"
                              alt="icon"
                              className={'mr-3'}
                              width={18}
                            />
                          }
                          disabledDate={(curr) => {
                            const startDate =
                              form.getFieldValue('workshift')?.start_date;
                            const endDate =
                              form.getFieldValue('workshift')?.end_date &&
                              dayjs(form.getFieldValue('workshift')?.end_date);

                            if (startDate)
                              return curr <= dayjs(startDate) || curr > endDate;
                            if (workshift.start_date)
                              return (
                                curr <= dayjs(workshift.start_date) ||
                                curr > endDate
                              );
                          }}
                          style={{
                            width: '100%',
                          }}
                        />
                      </Item>
                    ) : workshift?.cyclic_start_date ? (
                      dayjs(workshift?.cyclic_start_date).format('YYYY-MM-DD')
                    ) : (
                      ''
                    )}
                  </span>
                  <span
                    style={{
                      marginLeft: 'auto',
                    }}
                  >
                    <div className="is-flex">
                      <Button
                        icon={
                          editWorkshift ? (
                            <img
                              style={{ cursor: 'pointer', marginTop: '-4.5px' }}
                              src="/icons/accept.svg"
                              alt="accept"
                            />
                          ) : (
                            <EditIcon />
                          )
                        }
                        type="text"
                        onClick={handleChangeWorkShift}
                      />
                      <Button
                        icon={<CloseIcon />}
                        type="text"
                        onClick={() => {
                          if (!editWorkshift) return;
                          setState((p) => ({
                            ...p,
                            editWorkshift: false,
                          }));
                          form.setFieldValue('workshift', workshift);
                        }}
                      />
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <Options
              name={'working_time_unit'}
              height="50px"
              title={'Working Time Unit'}
              options={working_time_unit}
              width={'48.9%'}
            />
            <div
              className=" mt-5"
              style={{
                gap: 32,
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
              }}
            >
              <Options
                options={employment_contract}
                name={'employment_contract'}
                height="50px"
                width="100%"
                title={'Employment Contract'}
              />
              <Options
                height="50px"
                name={'professional_status'}
                options={professional_status}
                width="100%"
                title={'Professional Status'}
              />
              <Item
                name={'qualification'}
                style={{
                  width: '100%',
                }}
              >
                <CustomInput
                  title={'Qualification'}
                  height="50px"
                  fontSize={14}
                  width={'100%'}
                  maxLength={50}
                />
              </Item>
              <Item
                name={'coefficient'}
                style={{
                  width: '100%',
                }}
              >
                <CustomInput
                  title={'Coeffiecient'}
                  height="50px"
                  fontSize={14}
                  width={'100%'}
                  maxLength={50}
                />
              </Item>
            </div>
            <div className="is-flex" style={{ gap: 32 }}>
              <div style={{ width: '50%' }}>
                <Item name={'contract_end_date'}>
                  <CustomDatePicker
                    height="50px"
                    borderRadius={6}
                    fontSize={14}
                    title={'Contract End Date'}
                    disabledDate={(current) => {
                      const startDate = dayjs(
                        form.getFieldValue('contract_start_date'),
                      );
                      return current < startDate;
                    }}
                  />
                </Item>
              </div>
              <Options
                name={'contract_end_reason'}
                title={'Contract End Reason'}
                width={'50%'}
                height="50px"
                options={contractEndReasonOptions}
              />
            </div>
          </div>
        </div>
        {/*--------*/}
        {/*Job*/}
        <div className="form-wrapper mt-4">
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Job
          </h1>
          <div className="is-flex my-3" style={{ gap: 32 }}>
            <div style={{ width: '50%' }}>
              <Item
                name={'job_title'}
                rules={[{ required: true, message: 'Job Title is required' }]}
              >
                <CustomInput
                  height="50px"
                  fontSize={14}
                  title={'Job Title'}
                  maxLength={40}
                  required
                  width={'100%'}
                />
              </Item>
            </div>
            <div style={{ width: '50%' }}>
              <Item name={'job_number'}>
                <CustomInput
                  title={'ID Number'}
                  width={'100%'}
                  height="50px"
                  disabled
                  fontSize={14}
                  required
                  placeholder={String(Math.floor(Math.random() * 100000) + 2)}
                />
              </Item>
            </div>
          </div>
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Additional Information
          </h1>
          <div className="is-flex my-3" style={{ gap: 32 }}>
            <div style={{ width: '50%' }}>
              <Item name={'job_additional_info_1'}>
                <CustomInput
                  title={'Field 1'}
                  height="50px"
                  fontSize={14}
                  width={'100%'}
                />
              </Item>
            </div>
            <div style={{ width: '50%' }}>
              <Item name={'job_additional_info_2'}>
                <CustomInput
                  title={'Field 2'}
                  height="50px"
                  fontSize={14}
                  width={'100%'}
                />
              </Item>
            </div>
          </div>
          <div className="is-flex my-3" style={{ gap: 32 }}>
            <div style={{ width: '50%' }}>
              <Item name={'job_additional_info_3'}>
                <CustomInput
                  title={'Field 3'}
                  height="50px"
                  fontSize={14}
                  width={'100%'}
                />
              </Item>
            </div>
            <div style={{ width: '50%' }}>
              <Item name={'job_additional_info_4'}>
                <CustomInput
                  title={'Field 4'}
                  height="50px"
                  fontSize={14}
                  width={'100%'}
                />
              </Item>
            </div>
          </div>
          <Item name={'job_additional_info_5'}>
            <CustomInput
              title={'Field 5'}
              height="50px"
              fontSize={14}
              width={'100%'}
            />
          </Item>
        </div>
        {/*---*/}
        <div className="form-wrapper mt-4">
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Staff Leave / Absence Profile
          </h1>
          <div className="is-flex my-3">
            <Item
              name={'absence_policy_id'}
              rules={[
                {
                  required: true,
                  message: 'Staff leave / absence profile is required',
                },
              ]}
              style={{ width: '100%' }}
            >
              <Options
                name="absence_policy_id"
                options={staffLeaveList ? staffLeaveList : undefined}
                height="50px"
                required
                rule={[{ required: true }]}
                title="Staff leave / absence profile"
              />
            </Item>
          </div>
        </div>
        <h1
          className="form-wrapper_title "
          style={{ fontWeight: 600, fontSize: 24, margin: '32px 0px' }}
        >
          Admin
        </h1>
        <div className="form-wrapper">
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Platform Access
          </h1>
          <Item name={'expired_date'} className="add_item_date">
            <CustomDatePicker
              height="50px"
              borderRadius={6}
              fontSize={14}
              title={'End of access'}
              disabledDate={(current) => {
                const startDate = form.getFieldValue('contract_start_date');
                const endDate = form.getFieldValue('contract_end_date');

                const isBeforeStartDate = current.isBefore(dayjs(startDate));
                const isAfterEndDate = current.isAfter(dayjs(endDate));

                // Disable if the date is before start date or after end date
                return (
                  (startDate && isBeforeStartDate) ||
                  (endDate && isAfterEndDate)
                );
              }}
              width={'100%'}
            />
          </Item>
          <Item name={'active_modules'} className="add_item_checkbox">
            <Checkbox.Group
              options={checkBoxOption}
              onChange={(v) => console.log(v)}
              className="mb-4 is-flex"
              style={{ gap: 48 }}
            />
          </Item>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              width: '50%',
              color: '#E02C2C',
              fontSize: '12px',
              gap: 4,
              marginBottom: 24,
            }}
          >
            <span
              style={{
                color: hasLength ? '#52C41A' : '#E02C2C',
                transition: 'all ease-in-out',
                transitionDuration: '300ms',
              }}
            >
              Must be at least 8 characters in length{' '}
            </span>
            <span
              style={{
                color: hasLowercase ? '#52C41A' : '#E02C2C',
                transition: 'all ease-in-out',
                transitionDuration: '300ms',
              }}
            >
              Must contains at least one lower-case letter{' '}
            </span>
            <span
              style={{
                color: hasUppercase ? '#52C41A' : '#E02C2C',
                transition: 'all ease-in-out',
                transitionDuration: '300ms',
              }}
            >
              Must contains at least upper-case letter{' '}
            </span>
            <span
              style={{
                color: hasNumber ? '#52C41A' : '#E02C2C',
                transition: 'all ease-in-out',
                transitionDuration: '300ms',
              }}
            >
              Must contain at least one number{' '}
            </span>
          </div>
          <div className="is-flex" style={{ gap: 32 }}>
            <div style={{ width: '50%' }}>
              <Item
                name={'password'}
                required
                rules={[{ validator: validatePassword }]}
              >
                <CustomInput
                  title={'Password'}
                  height="50px"
                  fontSize={14}
                  maxLength={20}
                  required
                  onKeyPress={(e) => {
                    if (e.key === ' ') e.preventDefault();
                  }}
                  width={'100%'}
                />
              </Item>
            </div>
            <div style={{ width: '50%' }}>
              <Item
                name={'confirm_password'}
                dependencies={['password']}
                rules={[
                  { required: true, message: 'Confirm Password is required' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          'The confirm password that you entered do not match with password!',
                        ),
                      );
                    },
                  }),
                ]}
              >
                <CustomInput
                  title={'Confirm Password'}
                  required
                  height="50px"
                  fontSize={14}
                  maxLength={20}
                  onKeyPress={(e) => {
                    if (e.key === ' ') e.preventDefault();
                  }}
                  width={'100%'}
                />
              </Item>
            </div>
          </div>
          {/* <Item
            valuePropName={'checked'}
            name={'send_system_email'}
            className="add_item_checkbox"
          >
            <Checkbox>Send system access email</Checkbox>
          </Item> */}
          <h1 className="form-wrapper_title" style={{ fontWeight: 500 }}>
            Rights
          </h1>
          <Options
            name={'role'}
            options={user_profile}
            required
            height="50px"
            title={'User profile'}
            rule={[{ required: true }]}
            width={'100%'}
            disabled={true}
          />
          <div className="is-flex" style={{ gap: 32, marginTop: 32 }}>
            <Item
              name={'modify_name'}
              valuePropName={'checked'}
              className="add_item_checkbox"
            >
              <Checkbox>Modify names</Checkbox>
            </Item>
            <Item
              name={'display_import_code'}
              valuePropName={'checked'}
              className="add_item_checkbox"
            >
              <Checkbox>Display import code in exports</Checkbox>
            </Item>
          </div>
        </div>
        <div className="is-flex is-pulled-right my-4">
          <div
            className={
              'add_user_button  is-flex is-justify-content-center is-align-items-center  mr-3'
            }
            onClick={() => onBack(values)}
          >
            <img src="/icons/next_button.svg" alt="next" />
            <span>BACK</span>
          </div>
          <Item>
            <SubmitButton
              form={form}
              final
              passwordSuccess={passwordSuccess}
              step={4}
            />
          </Item>
        </div>
      </Form>
    </div>
  );
};

export default Four;
